import { Box } from "@mui/material";
import { useCustomColors } from "../hooks/useCustomColors";

const DataLoader = () => {
  const colors = useCustomColors();
  const dot = colors.accent.gold;

  return (
    <Box
      role="progressbar"
      aria-label="loading"
      sx={{
        width: "90px",
        height: "14px",
        background: `
          radial-gradient(circle 7px at bottom, ${dot} 92%, #0000) calc(100%/2) 0,
          radial-gradient(circle 7px at top, ${dot} 92%, #0000) calc(100%/2) 100%,
          conic-gradient(from 135deg at top, ${dot} 90deg, #0000 0) 0 0,
          conic-gradient(from -45deg at bottom, ${dot} 90deg, #0000 0) 0 100%`,
        backgroundSize: "calc(100%/2) 50%",
        backgroundRepeat: "repeat-x",
        animation: "dataLoader 3s infinite",
        "@keyframes dataLoader": {
          "0%": {
            backgroundPosition: "calc(100%/2) 0, calc(100%/2) 100%, 0 0, 0 100%",
          },
          "20%, 30%": {
            backgroundPosition:
              "calc(3*100%/4) 0, calc(100%/4) 100%, calc(100%/4) 0, calc(100%/-4) 100%",
          },
          "45%, 55%": {
            backgroundPosition: "100% 0, 0 100%, calc(100%/2) 0, calc(100%/-2) 100%",
          },
          "70%, 80%": {
            backgroundPosition:
              "calc(5*100%/4) 0, calc(100%/-4) 100%, calc(3*100%/4) 0, calc(3*100%/-4) 100%",
          },
          "100%": {
            backgroundPosition:
              "calc(3*100%/2) 0, calc(100%/-2) 100%, 100% 0, -100% 100%",
          },
        },
      }}
    />
  );
};

export default DataLoader;
